<template>
  <transition name="fade" mode="out-in">
    <div class="pl-tables">
      <div class="pl-table__container">
        <table class="pl-table" :class="{ 'table-disabled': isDisabled && !rangeEdit }">
          <tbody>
            <tr
              v-for="(hand, line) in table"
              :key="line">
              <td
                class="pl-table__cell"
                v-for="(item, cell) in hand"
                :key="cell">
                <button
                  type="button"
                  class="pl-table__btn"
                  @click="setHand(item)"
                  :class="[ item.type ]"
                  :disabled="isDisabled && !rangeEdit">
                  <span class="pl-table__cards">{{ item.cards }}</span>
                  <span
                    class="pl-table__marker"
                    v-for="marker in item.markers"
                    :key="marker['.key']"
                    :class="marker.color"
                    :style="{ width: marker.frequency + '%', backgroundColor: marker.color }"/>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <v-layout class="pl-table-frequency" v-if="rangeEdit" row wrap>
          <v-flex class="mr-3">
            <v-slider
              v-model="frequency"
              :color="'grey lighten-1'"
              :thumb-color="'grey lighten-1'"
              :min="1"
              label="Frequência"></v-slider>
          </v-flex>

          <v-flex shrink style="width: 60px">
            <v-text-field
              v-model="frequency"
              class="mt-0"
              hide-details
              single-line
              type="number"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout class="pl-table-status" v-if="rangeEdit" row wrap>
          <v-flex>
            <span class="pl-table-status__label"></span>
            <h4 class="title text-xs-center">
              {{ getSumFrequecies }}% das Mãos
              <span class="subheading font-weight-regular">({{ getSumCombos }} combos)</span>
            </h4>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import chunk from 'lodash/chunk'
import findIndex from 'lodash/findIndex'

export default {
  name: 'RangesTable',

  data () {
    return {
      isDisabled: true,
      frequency: 100
    }
  },

  computed: {
    ...mapGetters('hands', ['hands']),
    ...mapGetters('ranges', ['currentRanges']),
    ...mapGetters(['selectedRange', 'rangeEdit']),

    table () {
      return this.getHands()
    },

    getSumCombos () {
      let sumCombos = this.selectedRange.hands.map(hand => (hand.combos * (hand.frequency / 100)))
        .reduce((a, b) => a + b, 0)
      return sumCombos.toFixed(2)
    },

    getSumFrequecies () {
      let frequecies = this.selectedRange.hands.map(hand => ((hand.combos * (hand.frequency / 100)) / 1326) * 100)
        .reduce((a, b) => a + b, 0)
      return frequecies.toFixed(2)
    }
  },

  methods: {
    ...mapActions(['setSelectedRange']),

    getHands () {
      let arrayRanges = JSON.parse(JSON.stringify(this.currentRanges))
      let arrayHands = JSON.parse(JSON.stringify(this.hands))

      for (let range of arrayRanges) {
        for (let hand of range.hands) {
          let index = findIndex(arrayHands, { cards: hand.cards })

          if (index > -1) {
            arrayHands[index].markers.push({
              color: range.color,
              frequency: hand.frequency
            })
          }
        }
      }

      return chunk(arrayHands, 13)
    },

    setHand (item) {
      let index = findIndex(this.selectedRange.hands, { cards: item.cards })

      if (index > -1) {
        this.selectedRange.hands.splice(index, 1)
      } else {
        let frequency = 0

        for (let range of this.currentRanges) {
          for (let hand of range.hands) {
            if (hand.cards === item.cards) {
              frequency += hand.frequency
            }
          }
        }

        if ((frequency + this.frequency) > 100) {
          this.$root.$alert({
            title: 'Frequência excedida!',
            message: 'Essa mão não pode possuir uma frequência maior que 100%.'
          })
        } else {
          this.selectedRange.hands.push({
            cards: item.cards,
            combos: item.combos,
            frequency: this.frequency
          })
        }
      }
    }
  }
}
</script>
